<template>
	<Head>
		<Title>Page not found</Title>
		<Meta name="robots" content="noindex, nofollow" />
	</Head>
	<div class="page-content error-page">
		{{ error }}
		<span>{{ message }} - {{ statusCode }}</span>
		<NuxtLinkLocale to="/" class="error__link">Go back home</NuxtLinkLocale>
	</div>
</template>

<script setup>
const props = defineProps({
	error: Object,
});

const statusCode = computed(() => {
	if (props.error.statusCode) {
		return props.error.statusCode;
	}
	return props.error.status;
});

const message = computed(() => {
	if (props.error.statusMessage) {
		return props.error.statusMessage;
	}
	return props.error.message;
});
</script>

<style lang="scss">
.error-page {
	height: 100%;
	background: #fff;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	background-repeat: no-repeat;
	background-size: cover;
	text-align: center;
}

.error__link {
	color: #000;
	font-size: 18px;
	margin-top: 30px;
}
</style>
